import useSWR from "swr";


export const useFetchManagerStatus = (salesmanId?: string) => {
  const fetchKey = salesmanId ? `kuitan/salesmen/${salesmanId}/manager-status/` : null;
  const { data: isManager, error, isLoading } = useSWR<boolean>(fetchKey)
  return { isManager, isLoading, error };
};